// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData_ContactData__20AK_","Input":"ContactData_Input__2fK5-"};